import React, { useState } from "react";
import FormField from "../FormField/FormField";
import ProgressBar from "../../Components/ProgressBar/ProgressBar";
import styles from "./Step1.module.css";
import shared from "../../styles/shared.module.css";
import { step1Fields, consentField } from "../../data/formFields";
import { validateFields } from "../../Utilities/validateStep";

function Step1({ data, updateData, onNext, onFundingUnavailable, isSubmitting, submitError }) {
  const [errors, setErrors] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fieldErrors = validateFields([...step1Fields, consentField], data);
    if (fieldErrors.length > 0) {
      setErrors(fieldErrors);
      return;
    }
    setErrors([]);
    if (data[consentField.name] === "no") {
      onFundingUnavailable();
    } else {
      onNext();
    }
  };

  return (
    <>
      <h1 className={shared.pageTitle}>OUTGOING GLOBAL EXCHANGES</h1>
      <p className={shared.pageTitleSub}>Your global experience starts here.</p>
      <p className={shared.pageSubheading}>
        Welcome to AIESEC in Nigeria's Global Exchanges Program. Tell us a little about yourself and we'll help you find the right international experience.
      </p>
      <ProgressBar currentStep={1} totalSteps={3} />

      <div className={shared.fieldsCard}>
        <form onSubmit={handleSubmit}>
          <div className={styles.grid}>
            {step1Fields.map((field) => (
              <FormField key={field.name} field={field} value={data[field.name]} onChange={updateData} />
            ))}
            <div className={styles.fullWidth}>
              <FormField field={consentField} value={data[consentField.name]} onChange={updateData} />
            </div>
          </div>

          {errors.length > 0 && (
            <ul className={shared.errorList}>
              {errors.map((err) => <li key={err}>{err}</li>)}
            </ul>
          )}

          {submitError && <p className={styles.submitError}>{submitError}</p>}

          <button type="submit" className={shared.primaryButtonFull} disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Continue →"}
          </button>
        </form>
      </div>
    </>
  );
}

export default Step1;